import * as React from 'react';

type orderConfirmProps = {
    orderConfirmed: boolean,
    translations: any
};

export const OrderConfirm = ({orderConfirmed, translations}: orderConfirmProps) => {
    return (
        <>
            <div className="order-confirmed" style={{display: orderConfirmed ? 'block' : 'none'}}>
                <span className="confirm-icon">✓</span>
                <h2>{translations.thank_you}!</h2>

                <p>{translations.order_confirm_message}</p>

                <p className="mt32">
                    <a href="/" className="btn btn-primary btn-lg">{translations.go_home}</a>
                </p>
            </div>
        </>
    );
}
